import { MessageCircle } from 'lucide-react';

const WHATSAPP_GENERAL = 'https://wa.me/5551996777625?text=Ol%C3%A1!%20Gostaria%20de%20falar%20com%20um%20especialista%20iGreen.';

export default function WhatsAppFloat() {
  return (
    <a
      href={WHATSAPP_GENERAL}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-5 right-5 z-50 flex items-center gap-3 pl-2 pr-5 py-2 bg-green-600 hover:bg-green-700 text-white rounded-full shadow-lg shadow-green-600/30 transition-all duration-300 hover:shadow-xl hover:shadow-green-600/40 group"
      aria-label="Fale com um especialista no WhatsApp"
    >
      <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center shrink-0">
        <MessageCircle className="w-5 h-5" />
      </div>
      <span className="hidden whitespace-nowrap text-sm font-semibold 2xl:inline">
        Fale com um especialista
      </span>
    </a>
  );
}
